import React from "react";
import KendoDropdown from "../../../components/form/KendoDropdown";
import { useFetchParentCompanies } from "./hooks/useFetchParentCompanies";

export default function ParentCompanyDropdown({
  selectedParentCompany,
  setSelectedParentCompany,
}) {
  // Use the custom hook to fetch parent companies
  const { data: parentCompanyOrganizations = [], isLoading } =
    useFetchParentCompanies();

  return (
    <KendoDropdown
      dataSource={parentCompanyOrganizations || []}
      textField="label"
      idField="value"
      value={selectedParentCompany}
      sortBy="asc"
      onChange={(e) => {
        setSelectedParentCompany(e);
      }}
      loading={isLoading}
    />
  );
}
